module.exports = __webpack_public_path__ + "img/sonarsync.9daafb71.svg";